import { useContext } from 'react';
import { defer, type Observable, switchMap } from 'rxjs';

import useApi from './use-api';
import { AuthContext } from '../contexts/auth-context-provider';
import { type ApiHookType } from '../types';

export const useSecuredApi = (): ApiHookType => {
  const auth = useContext(AuthContext);
  const api = useApi();

  const withAuthHeaders = <T,>(call: (headers: HeadersInit) => Observable<T>): Observable<T> =>
    defer(() => auth.getValidAccessToken()).pipe(
      switchMap((token) =>
        call({
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        })
      )
    );

  return {
    get: (url, params, _, asBlob) =>
      withAuthHeaders((headers) => api.get(url, params, headers, asBlob)),

    post: (url, data, params, _, asBlob) =>
      withAuthHeaders((headers) => api.post(url, data, params, headers, asBlob)),

    put: (url, data, params, _) =>
      withAuthHeaders((headers) => api.put(url, data, params, headers)),

    patch: (url, data, params, _) =>
      withAuthHeaders((headers) => api.patch(url, data, params, headers)),

    delete: (url, data, params, _) =>
      withAuthHeaders((headers) => api.delete(url, data, params, headers)),
  };
};
export default useSecuredApi;
